import React, { useState } from 'react';
import styles from './Contact.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

// Import logos (ensure these images are in the assets folder)
import gmailLogo from '../assets/social&mediaImg/gmail.png';
import githubLogo from '../assets/social&mediaImg/github.png';
import instagramLogo from '../assets/social&mediaImg/instagram.png';
import linkedinLogo from '../assets/social&mediaImg/linkedin.png';

const Contact = () => {
  // Use state hooks to manage form inputs
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    
    // Log the current values (optional)
    console.log('Nume:', name);
    console.log('Email:', email);
    console.log('Mesaj:', message);

    // Reset the form fields by clearing the state
    setName('');
    setEmail('');
    setMessage('');
  };

  return (
    <div className={styles.contactsContainer}>
      <h1 className={styles.pageTitle}>Date de contact</h1>
      <p className={styles.introText}>
        Sunt disponibil pentru noi oportunități și colaborări. Pentru a discuta despre proiectul tău, mă poți contacta oricând prin detaliile de mai jos sau prin rețelele sociale.
      </p>

      <div className={styles.contactInfo}>
        <div className={styles.infoItem}>
          <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
          <div className={styles.infoDetails}>
            <h3 className={styles.infoTitle}>Email</h3>
            <p className={styles.infoValue}>oneamariusdaniel@gmail.com</p>
          </div>
        </div>

        <div className={styles.infoItem}>
          <FontAwesomeIcon icon={faPhone} className={styles.icon} />
          <div className={styles.infoDetails}>
            <h3 className={styles.infoTitle}>Telefon</h3>
            <p className={styles.infoValue}>0747295028</p>
          </div>
        </div>
      </div>

      <div className={styles.socialMedia}>
        <h2 className={styles.subtitle}>Mă găsești și pe:</h2>
        <ul className={styles.socialList}>
          <li className={styles.socialItem}>
            <a href="mailto:oneamariusdaniel@gmail.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={gmailLogo} alt="Gmail" className={styles.socialIcon} />
              <span className={styles.socialName}>Gmail</span>
            </a>
          </li>
          <li className={styles.socialItem}>
            <a href="https://github.com/OneaMarius" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={githubLogo} alt="GitHub" className={styles.socialIcon} />
              <span className={styles.socialName}>GitHub</span>
            </a>
          </li>
          <li className={styles.socialItem}>
            <a href="https://www.instagram.com/mariussaudaniel/" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={instagramLogo} alt="Instagram" className={styles.socialIcon} />
              <span className={styles.socialName}>Instagram</span>
            </a>
          </li>
          <li className={styles.socialItem}>
            <a href="https://www.linkedin.com/in/oneamarius/" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={linkedinLogo} alt="LinkedIn" className={styles.socialIcon} />
              <span className={styles.socialName}>LinkedIn</span>
            </a>
          </li>
          {/* You can add more links to other social platforms here */}
        </ul>
      </div>

      <div className={styles.contactFormSection}>
        <h2 className={styles.subtitle}>Trimite-mi un mesaj:</h2>
        {/* Add onSubmit handler to the form */}
        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="name" className={styles.label}>Nume:</label>
            {/* Bind the input to the name state */}
            <input 
              type="text" 
              id="name" 
              className={styles.input} 
              placeholder="Numele tău" 
              value={name}
              onChange={(e) => setName(e.target.value)} 
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>Email:</label>
            {/* Bind the input to the email state */}
            <input 
              type="email" 
              id="email" 
              className={styles.input} 
              placeholder="Adresa ta de email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="message" className={styles.label}>Mesaj:</label>
            {/* Bind the textarea to the message state */}
            <textarea 
              id="message" 
              className={styles.textarea} 
              rows="5" 
              placeholder="Scrie mesajul tău"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button type="submit" className={styles.submitButton}>Trimite mesaj</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;